import { z } from "zod"
import {
  base_circuit_json_error,
  type BaseCircuitJsonError,
} from "src/base_circuit_json_error"
import { expectTypesMatch } from "src/utils/expect-types-match"

export interface SchematicError extends BaseCircuitJsonError {
  type: "schematic_error"
  schematic_error_id: string
  error_type: "schematic_port_not_found"
  subcircuit_id?: string
}

export const schematic_error = base_circuit_json_error
  .extend({
    type: z.literal("schematic_error"),
    schematic_error_id: z.string(),
    // eventually each error type should be broken out into a dir of files
    error_type: z
      .literal("schematic_port_not_found")
      .default("schematic_port_not_found"),
    subcircuit_id: z.string().optional(),
  })
  .describe("Defines a schematic error on the schematic")

export type SchematicErrorInput = z.input<typeof schematic_error>
type InferredSchematicError = z.infer<typeof schematic_error>

expectTypesMatch<SchematicError, InferredSchematicError>(true)
